var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.handleClickOutside),expression:"handleClickOutside"}],staticClass:"absolute bg-base-0 z-10 mt-4 border-0.5 border-base-30 rounded-md shadow-dropdown",class:{
    'w-full': _vm.fullWidth,
    'top-full left-0': !_vm.right,
    'top-full right-0': _vm.right,
  }},[_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }